import React from "react";
import { Box, Container, Typography, Grid, Button } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { styled } from "@mui/system";

// Wrapper sekcji
const SectionWrapper = styled(Box)(({ theme }) => ({
  position: "relative",
  backgroundColor: theme.palette.primary.main,
  paddingTop: "100px",
  paddingBottom: "100px",
  overflow: "hidden",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundImage: "url(/pattern.svg)",
    backgroundRepeat: "repeat",
    backgroundSize: "contain",
    opacity: 0.1,
    zIndex: 0,
  },
}));

// Nagłówek z podkreśleniem
const UnderlinedHeading = styled("span")({
  position: "relative",
  zIndex: 1,
  display: "inline-block",
  "&::after": {
    content: '""',
    position: "absolute",
    zIndex: "-1",
    left: 0,
    bottom: 0,
    width: "50%",
    height: "30px",
    backgroundImage: "url(/img/redunderline.svg)",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    backgroundPosition: "bottom center",
  },
});
const Section4 = () => (
  <SectionWrapper component="section">
    <Container maxWidth="xl">
      <Grid container spacing={4} alignItems="center">
        {/* Lewa kolumna: tekst i button */}
        <Grid item size={{ xs: 12, md: 6 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
              height: "100%",
              pr: "50px",
              position: "relative",
              zIndex: 1,
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "28px", md: "54px" },
                fontWeight: "bold",
                color: "white",
                mb: 2,
              }}
              align="left"
            >
              <UnderlinedHeading>
                Także jako dodatek
                <br />
                do Revita
              </UnderlinedHeading>
            </Typography>

            <Typography
              variant="body1"
              sx={{
                fontSize: "18px",
                fontWeight: 400,
                color: "white",
                mb: 5,
              }}
              align="left"
            >
              Nie chcesz rezygnować ze sprawdzonego i znanego środowiska? <br />
              Nie musisz! Bimetria jest dostępna również w postaci wtyczki,
              którą zainstalujesz w oprogramowaniu Revit. <br /> <br />
              Pobierz wtyczkę do swojej wersji Revita:
            </Typography>
            <Box display={"flex"} gap={2} flexDirection={"column"}>
              <Box display={"flex"} gap={2}>
                <Button
                  component="a"
                  href="https://bimetriaspace.fra1.digitaloceanspaces.com/Addiny/Bimetria2024_install.bat"
                  variant="contained"
                  sx={{
                    width: "160px",
                    backgroundColor: "turquoise.main",
                    color: "white",
                    textTransform: "none",
                    fontWeight: 500,
                    fontSize: { xs: "16px", md: "18px" },
                    px: { xs: 3, md: 4 },
                    py: { xs: 1.5, md: 2 },
                  }}
                >
                  Revit 2024
                </Button>
                <Button
                  component="a"
                  href="https://bimetriaspace.fra1.digitaloceanspaces.com/Addiny/Bimetria2025_install.bat"
                  variant="contained"
                  sx={{
                    width: "160px",
                    backgroundColor: "turquoise.main",
                    color: "white",
                    textTransform: "none",
                    fontWeight: 500,

                    fontSize: { xs: "16px", md: "18px" },
                    px: { xs: 3, md: 4 },
                    py: { xs: 1.5, md: 2 },
                  }}
                >
                  Revit 2025
                </Button>
              </Box>
              <Box display={"flex"} gap={2}>
                <Button
                  component="a"
                  href="https://bimetriaspace.fra1.digitaloceanspaces.com/Addiny/Bimetria2026_install.bat"
                  variant="contained"
                  sx={{
                    width: "160px",
                    backgroundColor: "turquoise.main",
                    color: "white",
                    textTransform: "none",
                    fontWeight: 500,

                    fontSize: { xs: "16px", md: "18px" },
                    px: { xs: 3, md: 4 },
                    py: { xs: 1.5, md: 2 },
                  }}
                >
                  Revit 2026
                </Button>
                <Button
                  component="a"
                  href="https://bimetriaspace.fra1.digitaloceanspaces.com/Addiny/Bimetria2027_install.bat"
                  variant="contained"
                  sx={{
                    width: "160px",
                    backgroundColor: "turquoise.main",
                    color: "white",
                    textTransform: "none",
                    fontWeight: 500,

                    fontSize: { xs: "16px", md: "18px" },
                    px: { xs: 3, md: 4 },
                    py: { xs: 1.5, md: 2 },
                  }}
                >
                  Revit 2027
                </Button>
              </Box>
            </Box>
          </Box>
        </Grid>

        {/* Prawa kolumna: obraz */}
        <Grid item size={{ xs: 12, md: 6 }}>
          <Box sx={{ position: "relative" }}>
            <Box
              component="img"
              src="/img/revit.png"
              alt="Revit overlay"
              sx={{ width: "100%", display: "block" }}
            />
            <Box
              sx={{
                position: "absolute",
                bottom: "-30px",
                left: 0,
                width: "100%",
                height: "30px",
                backgroundImage: "url(/img/afterpicture.svg)",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Container>
  </SectionWrapper>
);

export default Section4;
